import { ApiCallError } from 'app/http/ApiCallError';

const handledStatuses = new Set([401, 412, 429, 500]);

export const shouldNotifyWorkspacesError = (error: unknown) => {
  if (!(error instanceof ApiCallError)) {
    return true;
  }
  if (error.refreshOutcome === 'auth-failure') {
    return false;
  }
  return !(error.status !== undefined && handledStatuses.has(error.status));
};
